<template lang='pug'>
  .offline-banner(:class='{ show: isOffline }')
    .alert-icon
    .offline-banner-text
      span.h5(v-t='$t("offlineText")')
      span(v-t='$t("reconnectText")')
</template>

<i18n>
{
  "lng_en": {
    "offlineText": "You are offline right now. ",
    "reconnectText": "Please connect to the internet to continue shopping."
  },
  "lng_id": {
    "offlineText": "You are offline right now. ",
    "reconnectText": "Please connect to the internet to continue shopping."
  },
  "lng_th": {
    "offlineText": "You are offline right now. ",
    "reconnectText": "Please connect to the internet to continue shopping."
  },
  "lng_zh": {
    "offlineText": "You are offline right now. ",
    "reconnectText": "Please connect to the internet to continue shopping."
  },
  "lng_ko": {
    "offlineText": "현재 오프라인 상태입니다. ",
    "reconnectText": "쇼핑을 계속하려면 인터넷에 연결해주세요. "
  }
}
</i18n>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      isOffline: state => state.layout.isOffline
    })
  }
}
</script>

<style scoped lang='scss'>
  .alert-icon {
    width: 60px;
    background-size: 35px 35px;
    background-repeat: no-repeat;
    background-image: url('../../assets/images/icons/alert.svg');
  }

  .offline-banner {
    @include ease-in-out-quad-transition;
    background-color: $grey-dark;
    padding: 15px 20px;
    max-height: $offline-banner-height;
    display: flex;
    position: fixed;
    top: -$offline-banner-height;
    z-index: $zindex-fixed;

    &.show {
      top: 0;
    }
  }

  .offline-banner-text {
    color: $white;
    margin-left: 15px;
  }
</style>
